export default "__VITE_ASSET__baa52741__"